import { AbortError as e } from "../../errors/abort-error.mjs";
import { AccessDenied as t } from "../../errors/access-denied.mjs";
import { BadRequest as n } from "../../errors/bad-request.mjs";
import { ConflictError as r } from "../../errors/conflict-error.mjs";
import { FailedDependency as i } from "../../errors/failed-dependency.mjs";
import { InternalError as a } from "../../errors/internal-error.mjs";
import { LockedError as o } from "../../errors/locked-error.mjs";
import { MaintenanceError as s } from "../../errors/maintenance-error.mjs";
import { NotFound as c } from "../../errors/not-found.mjs";
import { PayloadTooLarge as l } from "../../errors/payload-too-large.mjs";
import { TooManyRequests as u } from "../../errors/too-many-requests.mjs";
import { UnauthorizedResponse as d } from "../../errors/unauthorized-response.mjs";
import { UnprocessableContentError as f } from "../../errors/unprocessable-content-error.mjs";
import { checkAreThereFieldsErrors as p } from "../../errors/util/check-field-errors.mjs";
import { useTranslation as m } from "../../i18n.mjs";
import { isCancel as h } from "axios";
import { useCallback as g, useEffect as _, useState as v } from "react";
import { jsx as y } from "react/jsx-runtime";
//#region src/fetch/use-base-fetch/index.tsx
var b = ({ httpClient: b, useRouter: x, toast: S }) => function({ method: C, showFieldsErrorToast: w, stopErrorPropagation: T, badRequestHandler: E, unauthorizedResponseHandler: D, unprocessableContentHandler: O, internalErrorHandler: k, afterFetch: A, accessDeniedHandler: j, onErrorBeforeErrorHandlers: M, onNotFound: N, mock: P }) {
	let F = x(), { t: I } = m(), [L, R] = v(0), [z, B] = v(!1);
	return _(() => B(!!L), [L]), {
		fetcher: g(async (...m) => {
			R((e) => e + 1);
			let g = typeof process < "u" && process.env.NODE_ENV === "development" || typeof process < "u" && process.env?.NEXT_PUBLIC_APP_ENV === "development" || typeof process < "u" && process.env?.APP_ENV === "development";
			return (P && g ? new Promise((e, t) => {
				let n = P.delay ?? 3e3;
				setTimeout(() => {
					P.error ? t(P.error) : e(P.data);
				}, n);
			}) : b[C](m[0], m[1], m[2]).then(async (e) => e && (A ? await A(e.data, e) : e.data))).catch(M).catch(async (m) => {
				if (typeof window < "u" && m instanceof c) N ? N(m) : process.env.NODE_ENV !== "development" && F.replace("/not-found");
				else if (typeof window < "u" && m instanceof t) j ? j(m) : F.push("/403");
				else if (typeof window < "u" && m instanceof d) D ? D(m) : window.location.assign(m.redirect);
				else if (m instanceof s) S.error(I("core.error.maintenance_error"));
				else if (typeof window < "u" && m instanceof a) k ? k(m) : S.error(I("core.error.internal_error_message"));
				else if (m instanceof n) w && m.errors && p(m.errors.fields) && S.error(I("global.errors.fields_toast_message")), E ? E(m) : m.message && S.error(/* @__PURE__ */ y("p", {
					className: "primary-link-container",
					dangerouslySetInnerHTML: { __html: m.message }
				}));
				else if (m instanceof r) S.error(I("core.error.conflict_error_message"));
				else if (m instanceof f) O ? O(m) : S.error(m.message || I("core.error.conflict_error_message"));
				else if (m instanceof o) S.error(m.message);
				else if (m instanceof l) S.error(I("core.error.payload_to_large_error_message"));
				else if (m instanceof u) S.error(m.message || I("global.error"));
				else if (m instanceof i) S.error(/* @__PURE__ */ y("p", { dangerouslySetInnerHTML: { __html: m.message } }));
				else if (m instanceof e) throw m;
				else !(h(m) || m.code === "ECONNABORTED") && S.error(I("global.error"));
				if (!T) throw m;
			}).finally(() => R((e) => e - 1));
		}, [
			C,
			A,
			F,
			D,
			w,
			E,
			O,
			j,
			M
		]),
		isFetching: z
	};
};
//#endregion
export { b as getUseBaseFetch };
